require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./information-security-and-quality-assurance-information-security-and-quality-assurance-projects-anonymous-message-board.json") })
        }
      }, "path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-anonymous-message-board");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---information-security-and-quality-assurance-information-security-and-quality-assurance-projects-anonymous-message-board!./.cache/json/information-security-and-quality-assurance-information-security-and-quality-assurance-projects-anonymous-message-board.json
// module id = 2164
// module chunks = 231608221292675